import { render, staticRenderFns } from "./DC_HQ_5F.vue?vue&type=template&id=b53e531c&scoped=true"
import script from "./DC_HQ_5F.vue?vue&type=script&lang=js"
export * from "./DC_HQ_5F.vue?vue&type=script&lang=js"
import style0 from "./DC_HQ_5F.vue?vue&type=style&index=0&id=b53e531c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53e531c",
  null
  
)

export default component.exports